import { Component } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { Languages } from '../core/models/languages';

import { CoreModule } from '../core/core.module';

@Component({
    selector: 'app-root',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
	imports: [CoreModule],
    standalone: true
})
export class LandingComponent {

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private translate: TranslateService
	) {}

	ngOnInit(): void {
		this.router.events.subscribe((event: Event) => {
			if (event instanceof NavigationEnd) {
				let lang: Languages = this.route.snapshot.queryParams.lang;

				if (![Languages.English, Languages.Ukrainian, Languages.Polish, Languages.Russian].includes(lang)) {
					lang = Languages.English;
				}

				this.translate.use(lang);
			}
		});
	}
}